export function filterByValue({ children }, search) {
  return children.toLowerCase().includes(search.toLowerCase())
}
